//バナー
$(".top-banner__slider").slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  centerMode: true,
  centerPadding:'33%',
  speed: 1000,
  dots: true,
  responsive: [{
    breakpoint: 768,
    settings: {
      centerPadding:'19%',
    }
  }]
})

//ランキング
let rank_slider = $(".top-products__rankSlider-row");
let rank_list = $(".top-products__rankList");
let rank_item = $(".top-products__rankItem");
rank_item.eq(0).addClass("is-active");
rank_slider.slick({
  infinite: false,
  fade: true,
  slidesToShow: 1,
  arrows: false,
  dots: false,
  waitForAnimate: false,
  variableWidth: false,
  responsive: [{
    breakpoint: 767,
    settings: {
      fade: false,
      variableWidth: true,
      dots: true,
    }
  }]
});

rank_item.on("click",function(){
  index = $(this).index();
  rank_item.removeClass("is-active");
  $(this).addClass("is-active");
  rank_slider.slick('slickGoTo', index, false);
})